;
define("product_views_option_phone.tpl", function(){});

